import Component from '../inherited/Component'
import datepicker from 'js-datepicker'
import AjaxApi from '../lib/AjaxApi'
import axios from 'axios'

export default class DeliveryDatePicker extends Component {
    constructor (elem, theme, options, ctx) {
      super(elem, theme, options, ctx)
      this._postcodeForm = this._elem.querySelector('[data-postcode-form]')
      this._postcodeInput = this._elem.querySelector('[data-postcode-input]')
      this._postcodeError = this._elem.querySelector('[data-postcode-error]')
      this._postcodeSuccess = this._elem.querySelector('[data-postcode-success]')
      this._datePickerInput = this._elem.querySelector('[data-date-picker-input]')
      this._datePickerLabel = this._elem.querySelector('[data-date-picker-label]')
      this._mainCartForm = document.querySelector('[data-main-cart-form]')

      this._data = JSON.parse(this._elem.querySelector('[data-delivery-date-picker-data]').innerHTML)
      this._postcodeAreas = this._data.postcodes
      this._extraDayPostcodes = this._data.extraDayPostcodes
      this._blackoutDates = this._data.blackout
      
      this._currentDate = new Date()
      this._minDate = this._currentDate
      this._currentHour = this._minDate.getHours()
      this._blackoutAdded = false
      this._dateSelected = this._convertDate(this._datePickerInput.value)

      this._leadTime = 2
      if(this._currentHour >= this._data.cutOffTime) {
        this._leadTime = 3
      }
    }
    

    async mount () {
    
      this._updateCartAttributes('')
      this._datePickerInit()

      this._ctx.on('radiant--cart-update', (cart) => {
        this._reInit()
      })
        
      this._postcodeInput.addEventListener('keyup', e => {
        this._postcodeInput.value = this._postcodeInput.value.toLocaleUpperCase()
        this._postcodeError.classList.add('hide')
        this._postcodeSuccess.classList.add('hide')
      })
      this._postcodeForm.addEventListener('submit', e => {
        e.preventDefault()
        this._postcodeCheck()
      })
    }

    async _postcodeCheck() {
      let valid = this._postcodeForm.reportValidity()

      if (valid) {
        let postcodeEntered = this._postcodeForm.querySelector('[data-postcode-input]').value.replace(/\s+/g, '')
        let substringNum = postcodeEntered.length - 3
        let postcodePrefix = postcodeEntered.substring(0, substringNum)
        
        let postcodeMatch = false
        for (let i = 0; i < this._postcodeAreas.length; i++) {
            if(this._postcodeAreas[i] == postcodePrefix) {
                postcodeMatch = true
                break
            }
        }

        if(postcodeMatch) {
            this._datePickerLabel.classList.remove('hide')
            this._datePickerInput.classList.remove('hide')
            this._postcodeSuccess.classList.remove('hide')
            this._postcodeError.classList.add('hide')

            let extraDayNeeded = false

            for (let i = 0; i < this._extraDayPostcodes.length; i++) {
                if(this._extraDayPostcodes[i] == postcodePrefix) {
                    this._extraDayDate = new Date(this._minDate.getTime())
                    this._extraDayDate.setDate(this._extraDayDate.getDate() + 1)
                    if(this._extraDayDate.getDay() == 6) {
                        this._extraDayDate.setDate(this._extraDayDate.getDate() + 3)
                    } else if(this._extraDayDate.getDay() == 0) {
                        this._extraDayDate.setDate(this._extraDayDate.getDate() + 2)
                    }
                    this._datePicker.setMin(this._extraDayDate)
                    extraDayNeeded = true
                    break
                }
            }

            if(!extraDayNeeded) {
                this._datePicker.setMin(this._minDate)
            }
            
            this._datePickerInput.focus()

            gtag('event', 'postcode_delivery_check', {
                'event_category': 'Postcode',
                'event_label': 'Postcode Delivery Check',
                'postcode_accepted': true,
                'postcode_entered': postcodeEntered
            })
            

        } else {
            this._datePickerLabel.classList.add('hide')
            this._datePickerInput.classList.add('hide')
            this._postcodeSuccess.classList.add('hide')
            this._postcodeError.classList.remove('hide')
            this._updateCartAttributes('')
            this._mainCartForm.querySelector('button[type="submit"]').disabled = true

            gtag('event', 'postcode_delivery_check', {
                'event_category': 'Postcode',
                'event_label': 'Postcode Delivery Check',
                'postcode_accepted': false,
                'postcode_entered': postcodeEntered
            })
        }
      }
    }

    async _datePickerInit () {
        let datesToDisable = []

        for (let j = 0; j < this._blackoutDates.length; j++) {
            datesToDisable.push(this._convertDate(this._blackoutDates[j]))
        }

        this._currentDate = new Date(this._currentDate.setDate(this._currentDate.getDate() + this._data.daysToOffset))

        if(this._data.minDate) {
            this._minDate = new Date(this._data.minDate)
        } else {
            this._minDate = new Date(this._currentDate.getTime())
        }

        if(this._currentDate.getDay() == 5 || this._currentDate.getDay() == 6) {
            this._leadTime = this._leadTime + 2
        } else if(this._currentDate.getDay() == 0) {
            this._leadTime = this._leadTime + 1
        }

        if(this._currentDate.getDay() == 5 || this._currentDate.getDay() || 6 || this._currentDate.getDay() || 0) { // add extra day on Fridays/weekendsl as Monday delivery is not possible
            let currentDateTemp = new Date()
            currentDateTemp = new Date(currentDateTemp.setDate(currentDateTemp.getDate() + this._data.daysToOffset))
            let followingMonday = new Date(currentDateTemp.setDate(currentDateTemp.getDate() + 3))
            followingMonday = followingMonday.toLocaleDateString('en-GB')
            if(this._blackoutDates.includes(followingMonday)) { // if it's currently Friday and there is a blackout date on the following Monday, add an extra day
                this._leadTime = this._leadTime + 1
            }
        }

        if(this._data.weeksToAdd > 0) {
            this._minDate.setDate(this._minDate.getDate() + this._data.weeksToAdd * 7);
        }
    
        for (let lead = 0; lead < this._leadTime; lead++) {
            this._minDate.setDate(this._minDate.getDate() + 1)
        
            if(this._blackoutDates.includes(this._minDate.toLocaleDateString('en-GB'))) {
                this._minDate.setDate(this._minDate.getDate() + 1)
            }
        }

        if(this._minDate.getDay() == 0) {
            this._minDate.setDate(this._minDate.getDate() + 1)
        }
    

        if(this._dateSelected < this._minDate) {
            this._updateCartAttributes('')
            this._datePickerInput.value = ''
            this._dateSelected = ''
        }

        this._datePicker = datepicker(this._datePickerInput, {
            disabler: date => date.getDay() === 0 
                      || this._currentDate.getDay() === 7 && date.getDay() === 1
                      || this._currentDate.getDay() === 7 && date.getDay() === 2,
            formatter: (input, date, instance) => {
                const value = date.toLocaleDateString('en-GB')
                input.value = value
            },
            onSelect: (instance, date) => {
                if(date !== undefined) {
                    // a date has been chosen, we can allow checkout
                    this._updateCartAttributes(date.toLocaleDateString('en-GB'))
                    this._mainCartForm.querySelector('button[type="submit"]').disabled = false
                } else {
                    this._updateCartAttributes('')
                    this._mainCartForm.querySelector('button[type="submit"]').disabled = true
                }
            },
            startDay: 1,
            startDate: this._minDate,
            minDate: this._minDate,
            maxDate: this._convertDate(this._data.maxDate),
            disabledDates: datesToDisable,
            disableYearOverlay: true,
            dateSelected: this._dateSelected,
            noWeekends: true
        })
    }

    _convertDate (date) {
        if(date) {
            let splitDate = date.split('/')
            let month = splitDate[1] - 1
            return new Date(splitDate[2], month, splitDate[0])
        } else {
            return
        }
    }

   async _updateCartAttributes (date) {
    try {
        let data = await AjaxApi.updateCart({
            attributes: {
              'Delivery Date': date
            }
          })
      } catch (e) {
        console.error("ERROR")
        console.error(e.response.data)
        alert(e.response.data.description)
      }
    }

    async _reInit() {
        let toWaitFor = axios.get(window.location.pathname)
        let resp = await toWaitFor
        let parser = new DOMParser()
        let html = parser.parseFromString(resp.data, 'text/html')
        let fetchedElem = html.querySelector('[data-delivery-date-picker]')
        this._elem.parentNode.replaceChild(fetchedElem, this._elem)
        this._theme.mountComponents(fetchedElem.parentNode)
    }
}